import { render } from "./CreaCuenta.vue?vue&type=template&id=1c80ce3d&scoped=true"
import script from "./CreaCuenta.vue?vue&type=script&lang=js"
export * from "./CreaCuenta.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./CreaCuenta.vue?vue&type=style&index=1&id=1c80ce3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c80ce3d"]])

export default __exports__